export interface RequestDynamicFormState {
  isLoading: boolean;
  data: any;
}

export const requestDynamicFormInitialState: RequestDynamicFormState = {
  isLoading: false,
  data: null,
};
